interface Breadcrumb {
  link: string;
  text: string;
}

const searchForBreadcrumbsInNavigation = (
  nodes: {
    title?: string;
    url?: string;
    name?: string;
    items?: {
      title?: string;
      url?: string;
      name?: string;
      items?: {
        title?: string;
        url?: string;
        name?: string;
      }[];
    }[];
  }[],
  title: string
): Breadcrumb[] => {
  let result: Breadcrumb[] = [];

  nodes.forEach(node => {
    // 1st Level Navigation

    if (node.title === title) {
      result = [
        {
          link: '/',
          text: 'Home',
        },
        {
          link: node.url,
          text: node.title,
        },
      ];
    }

    // 2nd Level Navigation
    if (node.items) {
      node.items.some(subItem => {
        if (subItem.title === title) {
          result = [
            {
              link: '/',
              text: 'Home',
            },
            {
              link: node.url,
              text: node.title,
            },
            {
              link: subItem.url,
              text: subItem.title,
            },
          ];
          return true;
        }

        if (subItem.items) {
          subItem.items.some(subsubItem => {
            if (subsubItem.title === title) {
              result = [
                {
                  link: '/',
                  text: 'Home',
                },
                {
                  link: node.url,
                  text: node.title,
                },
                {
                  link: subItem.url,
                  text: subItem.title,
                },
                {
                  link: subsubItem.url,
                  text: subsubItem.name,
                },
              ];

              return true;
            }
            return false;
          });
        }

        // No match
        return false;
      });
    }
  });

  return result;
};

module.exports = searchForBreadcrumbsInNavigation;
